import { graphql } from 'src/gql'
import { LookupRelationshipsQueryVariables } from 'src/gql/graphql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQL, UseGraphqlOptions } from 'src/hooks/useGraphQL'

const document = graphql(/* graphql */`
  query LookupRelationships($key: String!, $relationshipModel: String!, $id: MongoID!, $page: Int, $limit: Int) {
    lookups {
      relationships(key: $key, relationshipModel: $relationshipModel, _id: $id, page: $page, limit: $limit) {
        count
        items {
          _id
          link
          title
        }
        pageInfo {
          currentPage
          hasNextPage
          hasPreviousPage
          pageCount
          limit
          totalCount
        }
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type LookupRelationships = NonNullable<NonNullable<NonNullable<TData>['lookups']>['relationships']>

const useLookupRelationships = (variables: LookupRelationshipsQueryVariables, opts?: UseGraphqlOptions<TData>): LookupRelationships => {
  const { data } = useGraphQL(document, variables, opts)
  return data?.lookups?.relationships ?? {
    count: 0,
    items: [],
    pageInfo: {}
  }
}

export { useLookupRelationships, document as lookupRelationshipsDocument }
